import '@fingermarkglobal/service-worker';
